import '@fingermarkglobal/service-worker';
